import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ReportHistoryDTO, ReportHistoryRequestDTO } from '../../../models/patient-history.models';
import { ServerRootService } from '../../../utils/routing/serverroot.service';

export abstract class PatientReportHistoryBaseService extends ServerRootService {
    protected readonly httpClient = inject(HttpClient);

    getReportHistory(payload: ReportHistoryRequestDTO): Observable<ReportHistoryDTO> {
        return this.httpClient.post<ReportHistoryDTO>(
            this.getServerRoot() + '/PatientHistory/GetReportHistory',
            payload,
            this.buildOptions(),
        );
    }
}
